import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";

import { connect } from "react-redux";
import {
  fetchExternalClientDetails,
  checkIsWBSEValid
} from "../../../redux/fui/index";
import { Grid, FormControlLabel, Radio, DialogActions } from "@material-ui/core";
import {
  StyledTooltip,
  TextHelperWrapper,
  TextHelperTypography,
  StyledRadioGroup,
  TopRadioWrapper,
  ConfigurationFormLabel,
} from "../FuiStyles";
import {
  longTextEndDate,
  rootExistedHint,
  rootWrongFormatHint,
  quickConfigurationTextHelperPlainInstance,
} from "../Constants/LongText";
import { useDebounce } from "../../../helper/customizedHooks";
import { DateTextFieldCommonComponent, DateTextFieldCommonComponentv2 } from "../DateTextFieldCommonComponent/DateTextFieldCommonComponent";
import {
  checkServiceNowTicket,
  checkWBSECode,
  checkDailyDataVolume,
  checkConcurrentUsers,
  checkBenefitsExpected,
  checkPOCname,
  createMaxDate
} from "./CommonFunctions";
import * as FormField from "./IndividualFormFields";
import * as PlatformFormField from "./IndividualFormFields";
import TextsmsIcon from "@material-ui/icons/Textsms";
import GeneralForm from "./GeneralForm";
import * as fuiRedux from "../../../redux/fui/index";
import { CommonDialog, CommonDialogV2 } from "../../common/CommonComponents/Dialog";
import { isValid } from "date-fns";
import { FlashOnRounded, FormatColorReset } from "@material-ui/icons";
import { AcceptButton2 } from "../../common/CommonComponents/Buttons";
import useFormValidationWithBorders from "./useFormValidationWithBorders";
import ValidationDialog from "./ValidationDialog";
const aSelectedInstanceFields = {
  DMSId: { type: "string", fieldName: "dmsId" },
  ClientName: { type: "string", fieldName: "clientName" },
  DeployRegion: { type: "object", fieldName: "deployRegion" },
  SAPContractID: { type: "object", fieldName: "sapContractId" },
  AaamPlatformType: { type: "object", fieldName: "aaamPlatformType" },
};

/**
 * Plain Instance Form
 * @author Isabel Sprengers
 * @version 2.0
 * @see Used in component: PlatformLicenseStepper
 */
const PlainInstance = ({
  values, // the value would be changed by user's input
  updatePIForm, //the function to update PIForm values which is from redux
  updateASelectedInstanceByField,
  createdBy, // user's EID
  checkDomainAvaliable, // the function that check whether DomainContextRoot exist or not from redux
  isRootExist, // the value that show whether DomainContextRoot exist or not from redux
  setIsAllValid, // the function to check whether all validations are satisfieds
  selectedEnvironment,
  getSelectedEnvironment,
  minDate,
  maxDate,
  getServiceEndDate,
  isServiceEndDateInvalid,
  getNotesValue,
  notesValidations,
  configurationType,
  classes,
  history,
  vendorName,
  email,
  idToken,
  isExternalClientLoading,
  externalClientData,
  externalClientError,
  fetchExternalClientDetails,
  isLoading,
  formClickSubmit,
  checkIsWBSEValid,
  isWBSEValid, // this value shows whether the WBSE is valid or not from redux
}) => {

  const config = configurationType === "quick";

  // check whether values are valid
  const [isServiceNowTicketValid, setIsServiceNowTicketValid] = useState(true);
  const [serviceNowAPIValid, setServiceNowAPIValid] = useState(null);
  const [isWBSECodeValid, setIsWBSECodeValid] = useState(true);
  // check whether WBSECode is equal to MD & I WBSE
  const [isWBSECodeMDIValid, setIsWBSECodeMDIValid] = useState(true);
  const [isProjectNameValid, setIsProjectNameValid] = useState(true);
  const [isDailyDataVolumeValid, setIsDailyDataVolumeValid] = useState(true);
  const [isConcurrentUsersValid, setIsConcurrentUsersValid] = useState(true);
  const [isBenefitsExpectedValid, setIsBenefitsExpectedValid] = useState(true);
  //   const [isUsersFieldValid, setUsersField] = useState(false);
  const [isNoteVisible, setNoteVisible] = useState(true);
  const [sapContractCodeLength, setSapContractCodeLength] = useState("0");
  const [domainContextRoot, setDomainContextRoot] = useState("[__]");
  const [regionCode, setRegionCode] = useState("[__]");
  const [isTeamNameSelected, setIsTeamNameSelected] = useState(true);
  const [env, setEnv] = useState("");
  const [customURL, setCustomURL] = useState("https://[__].mywizard-aiops.accenture.com/[__]");
  const [isPocvalid, setPocvalid] = useState(true);
  const [isPlanInputValid, setIsPlanInputValid] = useState(false);
  const [isChecked, setIsChecked] = useState(true);
  //validation popup initialize custom hook
  const { validationErrors, showValidationDialog, closeDialog, handleValidationResult } = useFormValidationWithBorders(values, isWBSEValid, selectedEnvironment);
  const handleContractAvailabilityChange = (event) => {
    const value = event.target.value;
    setIsChecked(value === "yes");
    // updatePIForm("IsContractIdAvailable", value);
    if (value === "no") {
      updatePIForm("IsContractIdAvailable", "no");
      updatePIForm("SAPContractID", "0000000000");
      updatePIForm("EndToEndUId", "");
      updatePIForm("ContractAvailabilityDate", createMaxDate(14));
      setSapContractCodeLength(10);
      setPocvalid(false);
    } else {
      setPocvalid(true);
      updatePIForm("SAPContractID", "");
      // updatePIForm("ClientName", "");
      updatePIForm("EndToEndUId", "");
      setSapContractCodeLength(0);
    }
  };

  useEffect(() => {
    updateASelectedInstanceByField({
      field: "aaamPlatformType",
      value: {
        Value: "myWizard AiOps Plain Instance",
      },
    });
  }, []);

  useEffect(() => {
    if (config) {
      setDomainContextRoot("[__]");
      setRegionCode("[__]");
    }
  }, [config]);

  if (config) {
    //updatePIForm("ClientName", "")
    updatePIForm("EndToEndUId", "")
    updatePIForm("Company", "")
    updatePIForm("AvanadeCountry", "")
    updatePIForm("AccentureCountry", "")
    updatePIForm("ContractAvailabilityDate", "")
  }

  if (!config) {
    if (externalClientData.length > 0) {
      updatePIForm("ClientName", externalClientData[0])
      updatePIForm("EndToEndUId", externalClientData[1])
      if (externalClientData[2] !== undefined)
        updatePIForm("Company", externalClientData[2])
      if (externalClientData[3] !== undefined)
        updatePIForm("AvanadeCountry", externalClientData[3])
      if (externalClientData[4] !== undefined)
        updatePIForm("AccentureCountry", externalClientData[4])
      if (isChecked && externalClientData[5] !== undefined)
        updatePIForm("GDPR", externalClientData[5] ? "yes" : "no")
      updatePIForm("ContractAvailabilityDate", "")
      updatePIForm("IsContractIdAvailable", "yes")
    }
  }

  if (!config) {
    (isDailyDataVolumeValid ||
      isConcurrentUsersValid ||
      isBenefitsExpectedValid) &&
      !isServiceEndDateInvalid && sapContractCodeLength == 10 && !externalClientError && isWBSEValid && isWBSECodeMDIValid && isServiceNowTicketValid && isProjectNameValid && isTeamNameSelected && isPocvalid
      ? setIsAllValid(true)
      : setIsAllValid(false);
  } else {
    (isServiceNowTicketValid ||
      isDailyDataVolumeValid ||
      isConcurrentUsersValid ||
      isBenefitsExpectedValid) &&
      !isServiceEndDateInvalid && isWBSEValid && isWBSECodeMDIValid && isProjectNameValid && isTeamNameSelected
      ? setIsAllValid(true)
      : setIsAllValid(false);
  }

  updatePIForm("VendorName", vendorName);
  updatePIForm("ConfigurationType", configurationType);

  // get user's input
  const handleChange = (event, fieldName) => {
    if (fieldName === "TentativeServiceEndDate" || fieldName === "ContractAvailabilityDate") {
      updatePIForm(fieldName, event);
      getServiceEndDate(event);
    } else if (fieldName === "TeamName") {
      if (event !== undefined || event !== null) {
        updatePIForm(fieldName, event);
        setIsTeamNameSelected(true);
        if (values.TeamName !== "Others") {
          updatePIForm("TeamNameOthers", "")
        }
      } else {
        setIsTeamNameSelected(false);
      }
    }
    else {
      const value = event.target.value;
      event.preventDefault();

      // if (fieldName === "Environment") {
      //   getSelectedEnvironment(value);
      // }
      if (fieldName === "RITM") {
        setIsServiceNowTicketValid(checkServiceNowTicket(value, isChecked, config));
      }
      if (fieldName === "WBSEcode") {
        const wbsevalue = value.toUpperCase()
        if (wbsevalue.trim() === "CBYDQ001") {
          setIsWBSECodeMDIValid(false)
        }
        // setIsWBSECodeValid(checkWBSECode(value));
        const isWBSEFormatValid = checkWBSECode(value);
        if (isWBSEFormatValid) {
          checkIsWBSEValid(value)
        }
      }
      if (fieldName === "Pocdetails") {
        setPocvalid(checkPOCname(value));
      }
      if (fieldName === "ProjectName") {
        if (value.length > 32 || value.length < 3) {
          setIsProjectNameValid(false)
        } else {
          setIsProjectNameValid(true)
        }
      }
      if (fieldName === "DailyDataVolume") {
        const regex = /^[1-9]\d*$/;
        if (value !== "" && !regex.test(value)) {
          setIsDailyDataVolumeValid(false);
          return false;
        }

        if (parseInt(value) > 200) {
          setIsDailyDataVolumeValid(false);
        } else {
          setIsDailyDataVolumeValid(true);
        }
      }
      if (fieldName === "ConcurrentUsers") {
        setIsConcurrentUsersValid(checkConcurrentUsers(value));
      }
      if (fieldName === "BenefitsExpected") {
        if (value[0] === "0") {
          setIsBenefitsExpectedValid(false);
        } else {
          setIsBenefitsExpectedValid(checkBenefitsExpected(value));
        }
      }
      if (fieldName === "TentativeServiceEndDate") {
        getServiceEndDate(value);
      }
      if (fieldName === "RequestNotes") {
        if (value.length > 0 && value.length < 247) {
          getNotesValue({ emptyString: false, maxLength: false });
        } else if (value.length === 0) {
          getNotesValue({ emptyString: true, maxLength: false });
        } else if (value.length > 246) {
          getNotesValue({ emptyString: false, maxLength: true });
        }
      }
      //update aSelectedInstance as other step relies on this data
      if (aSelectedInstanceFields[fieldName]) {
        const afieldDetails = aSelectedInstanceFields[fieldName];
        afieldDetails.type === "string" &&
          updateASelectedInstanceByField({
            field: afieldDetails.fieldName,
            value,
          });
        afieldDetails.type === "object" &&
          updateASelectedInstanceByField({
            field: afieldDetails.fieldName,
            value: {
              Value: value,
            },
          });
      }

      if (fieldName === "SAPContractID") {
        let sapLength = value.length
        setSapContractCodeLength(sapLength)
        if (sapLength == 10) {
          fetchExternalClientDetails(value)
        }
      }
      if (fieldName === "GDPR" && value === "yes") {
        updatePIForm("DeploymentRegion", "");
      }
      if (fieldName === "DeploymentRegion") {
        if (value == "sydney") {
          setRegionCode("dh")
        } else if (value == "virginia") {
          setRegionCode("dh1")
        } else if (value == "frankfurt") {
          setRegionCode("dh2")
        } else if (value == "singapore") {
          setRegionCode("dh3")
        } else if (value == "tokyo") {
          setRegionCode("dh4")
        } else if (value == "ireland") {
          setRegionCode("dh5")
        } else if (value == "london") {
          setRegionCode("dh6")
        } else {
          setRegionCode("[__]")
        }
      }
      if (fieldName === "DataClassification") {
        if (value === "Client-Production" || value === "Internal-Production") {
          setEnv("Production")
        } else if (value === "Client-NonProduction") {
          setEnv("Test")
          updatePIForm("Tier", "")
        } else if (value === "AppTeam-Development") {
          setEnv("Dev")
          updatePIForm("Tier", "")
        } else if (value === "AppTeam-Testing") {
          setEnv("Test")
          updatePIForm("Tier", "")
        } else {
          setEnv("")
          updatePIForm("Tier", "")
        }
      }
      updatePIForm(fieldName, value);
    }
  };


  getSelectedEnvironment(env);
  updatePIForm("Environment", env);

  // user can only input lower case letter and numbers in DomainContextRoot
  const handleChangeRoot = (event, fieldName) => {
    const re = /^[a-z0-9]*$/;
    const value = event.target.value;
    re.test(value) && updatePIForm(fieldName, value);
    setDomainContextRoot(value)
  };

  const handleChangeRootSuggestions = (event, value, fieldName) => {
    const re = /^[a-z0-9]*$/;
    // const value = event.target.value;
    re.test(value) && updatePIForm(fieldName, value);
    setDomainContextRoot(value)
  };

  // it would check whether the root has existed from DB once user stop typing longer than 0.3s
  const debouncedValue = useDebounce(domainContextRoot, 300);
  useEffect(() => {
    debouncedValue && checkDomainAvaliable(debouncedValue);
  }, [debouncedValue]);

  const isGDPR = values.GDPR === "yes";
  const isAAAMTermsConditions = values.AAAMTermsConditions === "yes";

  const handleChangeMobileNo = (event, fieldName) => {
    const re = /^[0-9]{0,}$/;
    const value = event.target.value;
    re.test(value) && updatePIForm(fieldName, value);
  };

  //form validation
  const validateInputFields = (step) => {
    // If not final submit, allow navigation (no validation)
    if (step !== 'step2' && step !== 'submit') {
      return true;
    }

    let ispass = true;
    const missingFields = [];

    // Final submit validation - validate ALL fields
    const allFieldsRequired = [
      'ProjectName',
      'WBSEcode',
      'SecondaryPOC',
      'DataClassification',
      'TeamName',
      'RequestNotes',
      'DeploymentRegion',
      'DomainContextRoot',
      'Environment',
      'AdminDistributionGroup',
      'TentativeServiceEndDate'
    ];

    // Add conditional fields based on configuration
    if (!config) {
      if (isChecked) {
        allFieldsRequired.push('SAPContractID');
      } else {
        allFieldsRequired.push('Pocdetails', 'ClientName');
      }
      // RITM is always mandatory regardless of SAP Contract checkbox
      allFieldsRequired.push('RITM');
      allFieldsRequired.push('DailyDataVolume', 'UsersDistributionGroup');
    }

    // Check for missing fields (basic empty validation - red borders handled by hook)
    for (const fieldname of allFieldsRequired) {
      if (fieldname === "WBSEcode") {
        // WBSE validation: empty OR API validation failed
        if (!values[fieldname] || values[fieldname] === "" || !isWBSEValid) {
          missingFields.push(fieldname);
          ispass = false;
        }
      } else if (fieldname === "RITM") {
        if (!values.RITM || values.RITM === "" || values.RITM === null) {
          missingFields.push(fieldname);
          ispass = false;
        } else if (serviceNowAPIValid === false) {
          missingFields.push(`${fieldname} (not found in records)`);
          ispass = false;
        } else if (!isServiceNowTicketValid) {
          missingFields.push(`${fieldname} (invalid format)`);
          ispass = false;
        }
      } else if (fieldname === "TentativeServiceEndDate" && (!selectedEnvironment || selectedEnvironment === "")) {
        // TentativeServiceEndDate requires environment to be selected first
        missingFields.push(fieldname);
        ispass = false;
      } else if (fieldname === "Pocdetails") {
        if (values['Pocdetails'] === "" || !isPocvalid && values['Pocdetails'] !== "") {
          missingFields.push(fieldname);
          ispass = false;
        }
      } else if (values[fieldname] === "" || values[fieldname] === undefined || values[fieldname] === null) {
        missingFields.push(fieldname);
        ispass = false;
      }
    }

    // Use the hook to handle validation results (red borders + dialog)
    handleValidationResult(ispass, missingFields, formClickSubmit);
    return ispass;
  }


  return (
    <>
      <GeneralForm
        isPlanInputValid={isPlanInputValid}
        FormId={vendorName === "MCC" ? 0 : 10}
        validateInputFields={validateInputFields}
        ClientContractFields={

          <div>
            {!config ?
              <TopRadioWrapper>
                <ConfigurationFormLabel component="legend">
                  Is a Contract ID available?
                </ConfigurationFormLabel>


                <StyledRadioGroup
                  aria-label="contract-available"
                  name="contract-available"
                  value={isChecked ? "yes" : "no"}
                  onChange={handleContractAvailabilityChange}
                  row
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio color="primary" />}
                    label="YES"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio color="primary" />}
                    label="NO"
                  />
                </StyledRadioGroup>
              </TopRadioWrapper>
              : ""
            }
            {(!isChecked && !config) &&
              <div style={{ fontSize: "small", color: "#0041F0" }}>
                <em>
                  To proceed with provisioning without a Contract ID, please provide the following mandatory details
                </em>
                <ul>
                  <li>WBSE Code (used for chargeback if contract is not provided)</li>
                  <li>Opportunity ID (for deal tracking and reference)</li>
                  <li>Expected Contract Availability Date (must be within 42 days)</li>
                  <li>Client Point of Contact (name and email for contract follow-up)</li>
                </ul>
              </div>
            }
            <div style={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={2}
              >
                {(!config && isChecked) ?
                  <Grid item xs={4}>
                    {PlatformFormField.SAPContractIDPlatformField(values, handleChange, externalClientError, isExternalClientLoading, sapContractCodeLength)}
                  </Grid>
                  : (!config && !isChecked) ?
                    <Grid item xs={4}>
                      {FormField.Pocvalid(handleChange, values, isPocvalid)}
                    </Grid>
                    : <></>
                }
                {(!config &&
                  isChecked &&
                  sapContractCodeLength === 10 &&
                  !isExternalClientLoading &&
                  !externalClientError) &&
                  <Grid item xs={4}>
                    {PlatformFormField.ClientNamePlatformField(
                      values,
                      handleChange,
                      externalClientData[0]
                    )}
                  </Grid>
                }
                {!config &&
                  isChecked &&
                  sapContractCodeLength === 10 &&
                  !isExternalClientLoading &&
                  !externalClientError && (
                    <Grid item xs={4}>
                      {PlatformFormField.EndToEndUIdPlatformField(
                        values,
                        handleChange,
                        externalClientData[1]
                      )}
                    </Grid>
                  )
                }
                {(!config && !isChecked) &&
                  <Grid item xs={4}>
                    <StyledTooltip
                      title={longTextEndDate}
                      placement="left-start"
                      noValidate
                    >
                      <DateTextFieldCommonComponentv2
                        tentativeServiceEndDate={values.ContractAvailabilityDate}
                        minDate={0}
                        maxDate={createMaxDate(27)}
                        handleChange={handleChange}
                        idkey="ContractAvailabilityDate"
                        label="Contract Availability Date"
                      />
                    </StyledTooltip>
                  </Grid>
                }
                {(!config) &&
                  <Grid item xs={4}>
                    {FormField.ServiceNowTicket(handleChange, values, isServiceNowTicketValid, setServiceNowAPIValid, configurationType)}
                  </Grid>
                }
                {(!config && !isChecked) &&
                  <Grid item xs={4}>
                    {FormField.ClientNamePlatformInternal(handleChange, values)}
                  </Grid >}

                <Grid item xs={4}>
                  {FormField.ProjectNameField(handleChange, values, isProjectNameValid)}
                </Grid>
                <Grid item xs={4}>
                  {FormField.WBSECodeField(handleChange, values, isWBSECodeValid, isWBSECodeMDIValid, isWBSEValid, isLoading)}
                </Grid >
                {config &&
                  <Grid item xs={4}>
                    {FormField.ServiceNowTicket(handleChange, values, isServiceNowTicketValid, setServiceNowAPIValid, configurationType)}
                  </Grid>
                }
                <Grid item xs={4}>
                  {FormField.SecondaryContact(handleChange, values, config)}
                </Grid>
                <Grid item xs={4}>
                  {FormField.DataClassificationField(handleChange, values, configurationType)}
                </Grid>
                <Grid item xs={4}>
                  {FormField.TeamNamesField(handleChange, values, isTeamNameSelected, 'gtaad', configurationType)}
                </Grid >
                {values.TeamName === "Others" &&
                  <Grid item xs={4}>
                    {FormField.TeamNameOthers(handleChange, values)}
                  </Grid >
                }
                {
                  (config &&
                    <Grid item xs={4}>
                      {FormField.ClientNamePlatformInternal(handleChange, values)}
                    </Grid>
                  )
                }
                {/* {config &&
                <Grid item xs={4}>
                  {FormField.ClientNamePlatformInternal(handleChange, values)}
                </Grid >
              } */}


                <Grid item xs={12}>
                  {PlatformFormField.RequestNotesPlatformField(
                    values,
                    handleChange,
                    notesValidations
                  )}
                </Grid>
              </Grid>
            </div>
          </div>
        }
        EnvironmentFields={
          <div>
            {/* {!config ? <p> Expected Custom URL: <span style={{ color: " #0041F0" }}>https://{regionCode}.mywizard-aiops.com/{domainContextRoot}</span></p> : ""} */}
            <div style={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={2}
              >

                {vendorName !== "MCC" &&
                  <Grid item xs={12}>
                    {PlatformFormField.GDPRPlatformField(
                      values,
                      handleChange,
                      isGDPR,
                      classes,
                      config,
                      isChecked
                    )}
                  </Grid>
                }

                {vendorName === "MCC"
                  ? <Grid item xs={3}>
                    {PlatformFormField.DeploymentRegionPlatformMccField(
                      values,
                      handleChange
                    )}
                  </Grid>
                  : <Grid item xs={3}>
                    {PlatformFormField.DeploymentRegionPlatformFieldWithGTAD(
                      values,
                      handleChange,
                      isGDPR,
                      false,
                      values.TeamName,
                      configurationType
                    )}
                  </Grid>
                }

                <Grid item xs={4}>
                  {!config ? PlatformFormField.DomainContextRootPlatformFieldClient(
                    values,
                    handleChangeRootSuggestions,
                    // handleChangeRoot,
                    isRootExist,
                    rootExistedHint,
                    rootWrongFormatHint,
                    externalClientData,
                    domainContextRoot,
                    isLoading
                  ) : PlatformFormField.DomainContextRootPlatformField(
                    values,
                    handleChangeRoot,
                    isRootExist,
                    rootExistedHint,
                    isLoading
                  )}
                </Grid>
                {!config &&
                  <Grid item xs={4}>
                    {PlatformFormField.DailyDataVolumePlatformField(
                      values,
                      handleChange,
                      isDailyDataVolumeValid
                    )}
                  </Grid>
                }
                {/* <Grid item xs={3}> */}
                {/* {PlatformFormField.EnvironmentPlatformField(values, handleChange)} */}
                <Grid item xs={3}>
                  {PlatformFormField.EnvironmentField(values, handleChange, env)}
                </Grid>
                {/* {values.Environment === "Production" &&
                <Grid item xs={3}> 
                  {PlatformFormField.TierPlatformField(values, handleChange)}
                </Grid>
              } */}
              </Grid>
            </div>
          </div>
        }
        ApplicationFields={
          <div style={{ flexGrow: 1 }}>
            <Grid
              container
              spacing={2}
            >
              <Grid item xs={6}>
                {FormField.AdminDistributionGroupField(handleChange, values)}
              </Grid>
              {!config &&
                <Grid item xs={6}>
                  {FormField.UsersDistributionGroupField(handleChange, values)}
                </Grid>
              }
              <Grid item xs={6}>
                <StyledTooltip
                  title={longTextEndDate}
                  placement="left-start"
                  noValidate
                >
                  <DateTextFieldCommonComponent
                    tentativeServiceEndDate={values.TentativeServiceEndDate}
                    selectedEnvironment={selectedEnvironment}
                    isServiceEndDateInvalid={isServiceEndDateInvalid}
                    minDate={minDate}
                    maxDate={maxDate}
                    handleChange={handleChange}
                  />
                </StyledTooltip>
              </Grid>
            </Grid>
          </div>
        }
        history={history}
      ></GeneralForm>
      <ValidationDialog
        open={showValidationDialog}
        onClose={closeDialog}
        errors={validationErrors}
      />
      {!isChecked && (
        <CommonDialogV2
          open={isNoteVisible}
          onClose={() => setNoteVisible(false)}
          title={"Note"}
          textContent={
            <div>
              <div style={{ textAlign: 'center', fontSize: '1.1em', fontWeight: '500' }}>If a valid contract is not provided within the 4-week period</div>
              <ul>
                <li>
                  Provisioned services will be automatically stopped
                </li>
                <li>
                  Cost recovery will be initiated using the provided WBSE code
                </li>
              </ul>
            </div>
          }
          dialogActions={
            <DialogActions>
              <AcceptButton2 onClick={() => setNoteVisible(false)} label={"Ok"} />
            </DialogActions>
          }
        ></CommonDialogV2>
      )}
    </>
  );
};

const MSTP = (state, ownProps) => ({
  isRootExist: state.fui.isRootExist,
  values: state.fui.PIForm,
  configurationType: state.fui.configurationType,
  email: state.auth.userDetails.email,
  idToken: state.auth.idToken,
  externalClientData: state.fui.externalClientData,
  externalClientError: state.fui.externalClientError,
  isExternalClientLoading: state.fui.isExternalClientLoading,
  isLoading: state.fui.isLoading,
  isWBSEValid: state.fui.isWBSEValid,
});

export default connect(MSTP, {
  updatePIForm: fuiRedux.updatePIForm,
  updateASelectedInstanceByField: fuiRedux.updateASelectedInstanceByField,
  checkDomainAvaliable: fuiRedux.checkRootExisted,
  fetchExternalClientDetails,
  checkIsWBSEValid
})(withRouter(PlainInstance));
